import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import HintIcon from "../../../../shared/icons/HintIcon";
import { InsuranceApplication } from "../../../../../services";
import CustomInput from "../../../../custom/custom-input/CustomInput";
import CustomPhoneInput from "../../../../custom/custom-phone-input/CustomPhoneInput";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import InsuranceModal from "./InsuranceModal";
import style from "./InsuranceBlock.module.scss";

export default function InsuranceApplicationModal({ orderId, onClose, onSubmitted }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const [name, setName] = useState(() =>
    [user?.surname, user?.name, user?.patronymic].filter(Boolean).join(" "),
  );
  const [phone, setPhone] = useState(user?.phoneNumber || "");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submitting = useRef(false);
  const active = useRef(false);
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (submitting.current) return;
    const phoneNumber = phone.replace(/\D/g, "");
    if (!name.trim() || phone.includes("_") || !/^\d{7,15}$/.test(phoneNumber)) {
      setError(t("expeditorInsurance.applicationValidation"));
      return;
    }
    submitting.current = true;
    setBusy(true);
    setError("");
    try {
      const { data } = await InsuranceApplication.create({ name: name.trim(), phoneNumber, orderId });
      if (active.current) onSubmitted(data);
    } catch (error) {
      if (active.current) setError(error?.errorText || t("expeditorInsurance.submitError"));
    } finally {
      submitting.current = false;
      if (active.current) setBusy(false);
    }
  };

  return (
    <InsuranceModal
      title={t("expeditorInsurance.applicationTitle")}
      description={t("expeditorInsurance.applicationDescription")}
      onClose={onClose}
      busy={busy}
    >
      <form onSubmit={submit} className={style.form}>
        <CustomInput
          labelText={t("expeditorInsurance.fullName")}
          placeholder={t("expeditorInsurance.namePlaceholder")}
          value={name}
          onChangeValue={setName}
          isBgGray
          isDisabled={busy}
        />
        <CustomPhoneInput
          labelText={t("expeditorInsurance.phone")}
          value={phone}
          onChangeValue={setPhone}
          isBgGray
          isDisabled={busy}
        />
        <div className={style.notice}>
          <HintIcon aria-hidden="true" />
          <span>{t("expeditorInsurance.agreementNotice")}</span>
        </div>
        {error && (
          <p role="alert" className={style.error}>
            {error}
          </p>
        )}
        <div className={style.footer}>
          <CustomButton
            type="button"
            text={t("common.cancel")}
            isNavy
            isWhite
            onClick={onClose}
            disabled={busy}
            isDisabled={busy}
          />
          <CustomButton
            type="submit"
            text={t("expeditorInsurance.submitApplication")}
            isNavy
            isLoading={busy}
            disabled={busy || !name.trim() || !phone.trim()}
            isDisabled={busy || !name.trim() || !phone.trim()}
          />
        </div>
      </form>
    </InsuranceModal>
  );
}
